import type { POSItem, POSCategory, POSOrder } from '../types';

// 카테고리 목록 - 농산물 박스 공장 직판/소매
export const categories: POSCategory[] = [
  { id: 'all', name: '전체', itemCount: 24 },
  { id: 'fruit-box', name: '과일박스', itemCount: 8 },
  { id: 'vegetable-box', name: '채소박스', itemCount: 6 },
  { id: 'special-box', name: '특수박스', itemCount: 5 },
  { id: 'supplies', name: '포장부자재', itemCount: 5 },
];

// 상품 목록 - 농산물 박스 및 포장재
export const items: POSItem[] = [
  // 과일박스
  {
    id: 'item-001',
    code: 'BOX-A10',
    name: '사과박스 10kg',
    category: 'fruit-box',
    price: 2800,
    stock: 450,
    unit: '개',
    barcode: '8809123456001',
    description: '사과 10kg용 인쇄 골판지 박스 (E골)',
  },
  {
    id: 'item-002',
    code: 'BOX-A05',
    name: '사과박스 5kg',
    category: 'fruit-box',
    price: 2200,
    stock: 380,
    unit: '개',
    barcode: '8809123456002',
    description: '사과 5kg용 인쇄 골판지 박스 (E골)',
  },
  {
    id: 'item-003',
    code: 'BOX-P15',
    name: '배박스 15kg',
    category: 'fruit-box',
    price: 3500,
    stock: 280,
    unit: '개',
    barcode: '8809123456003',
    description: '배 15kg용 프리미엄 인쇄 박스 (B골)',
  },
  {
    id: 'item-004',
    code: 'BOX-P07',
    name: '배박스 7.5kg',
    category: 'fruit-box',
    price: 2600,
    stock: 320,
    unit: '개',
    barcode: '8809123456004',
    description: '배 7.5kg용 인쇄 골판지 박스 (E골)',
  },
  {
    id: 'item-005',
    code: 'BOX-G05',
    name: '포도박스 5kg',
    category: 'fruit-box',
    price: 2400,
    stock: 420,
    unit: '개',
    barcode: '8809123456005',
    description: '포도 5kg용 통풍 구멍 박스',
  },
  {
    id: 'item-006',
    code: 'BOX-C20',
    name: '감귤박스 20kg',
    category: 'fruit-box',
    price: 3200,
    stock: 350,
    unit: '개',
    barcode: '8809123456006',
    description: '감귤 20kg용 대형 골판지 박스 (BC골)',
  },
  {
    id: 'item-007',
    code: 'BOX-C10',
    name: '감귤박스 10kg',
    category: 'fruit-box',
    price: 2500,
    stock: 480,
    unit: '개',
    barcode: '8809123456007',
    description: '감귤 10kg용 인쇄 골판지 박스',
  },
  {
    id: 'item-008',
    code: 'BOX-S03',
    name: '딸기박스 3kg',
    category: 'fruit-box',
    price: 1800,
    stock: 520,
    unit: '개',
    barcode: '8809123456008',
    description: '딸기 3kg용 칸막이 포함 프리미엄 박스',
  },

  // 채소박스
  {
    id: 'item-009',
    code: 'BOX-V10',
    name: '채소박스 10kg',
    category: 'vegetable-box',
    price: 2100,
    stock: 380,
    unit: '개',
    barcode: '8809123456101',
    description: '채소용 범용 골판지 박스 (E골)',
  },
  {
    id: 'item-010',
    code: 'BOX-V05',
    name: '채소박스 5kg',
    category: 'vegetable-box',
    price: 1600,
    stock: 450,
    unit: '개',
    barcode: '8809123456102',
    description: '채소용 소형 골판지 박스',
  },
  {
    id: 'item-011',
    code: 'BOX-M05',
    name: '버섯박스 5kg',
    category: 'vegetable-box',
    price: 2000,
    stock: 280,
    unit: '개',
    barcode: '8809123456103',
    description: '버섯용 통풍 박스 (양면 코팅)',
  },
  {
    id: 'item-012',
    code: 'BOX-W15',
    name: '수박박스 15kg',
    category: 'vegetable-box',
    price: 3800,
    stock: 180,
    unit: '개',
    barcode: '8809123456104',
    description: '수박 1~2과용 대형 강화 박스 (BC골)',
  },
  {
    id: 'item-013',
    code: 'BOX-T05',
    name: '토마토박스 5kg',
    category: 'vegetable-box',
    price: 2200,
    stock: 320,
    unit: '개',
    barcode: '8809123456105',
    description: '토마토용 완충 칸막이 포함 박스',
  },
  {
    id: 'item-014',
    code: 'BOX-PP10',
    name: '파프리카박스 10kg',
    category: 'vegetable-box',
    price: 2400,
    stock: 250,
    unit: '개',
    barcode: '8809123456106',
    description: '파프리카용 프리미엄 인쇄 박스',
  },

  // 특수박스
  {
    id: 'item-015',
    code: 'BOX-GIFT-S',
    name: '선물세트박스 (소)',
    category: 'special-box',
    price: 4500,
    stock: 150,
    unit: '개',
    barcode: '8809123456201',
    description: '명절 선물용 고급 인쇄 박스 (3kg)',
  },
  {
    id: 'item-016',
    code: 'BOX-GIFT-M',
    name: '선물세트박스 (중)',
    category: 'special-box',
    price: 5500,
    stock: 120,
    unit: '개',
    barcode: '8809123456202',
    description: '명절 선물용 고급 인쇄 박스 (5kg)',
  },
  {
    id: 'item-017',
    code: 'BOX-GIFT-L',
    name: '선물세트박스 (대)',
    category: 'special-box',
    price: 7000,
    stock: 80,
    unit: '개',
    barcode: '8809123456203',
    description: '명절 선물용 프리미엄 인쇄 박스 (10kg)',
  },
  {
    id: 'item-018',
    code: 'BOX-COLD',
    name: '저온유통박스',
    category: 'special-box',
    price: 8500,
    stock: 60,
    unit: '개',
    barcode: '8809123456204',
    description: '보냉재 포함 저온유통용 특수 박스',
  },
  {
    id: 'item-019',
    code: 'BOX-ECO',
    name: '친환경 인증박스',
    category: 'special-box',
    price: 3200,
    stock: 200,
    unit: '개',
    barcode: '8809123456205',
    description: '친환경 인증 재생지 사용 박스',
  },

  // 포장부자재
  {
    id: 'item-020',
    code: 'SUP-TAPE',
    name: '박스 테이프',
    category: 'supplies',
    price: 3500,
    stock: 580,
    unit: '롤',
    barcode: '8809123456301',
    description: '48mm x 50M 투명 박스 테이프',
  },
  {
    id: 'item-021',
    code: 'SUP-FOAM',
    name: '완충재 (EPE폼)',
    category: 'supplies',
    price: 1200,
    stock: 800,
    unit: '장',
    barcode: '8809123456302',
    description: '과일 보호용 EPE 완충재',
  },
  {
    id: 'item-022',
    code: 'SUP-NET',
    name: '과일망',
    category: 'supplies',
    price: 150,
    stock: 2000,
    unit: '개',
    barcode: '8809123456303',
    description: '과일 개별 포장용 발포망',
  },
  {
    id: 'item-023',
    code: 'SUP-TRAY',
    name: '종이 트레이',
    category: 'supplies',
    price: 280,
    stock: 1500,
    unit: '개',
    barcode: '8809123456304',
    description: '과일 배열용 종이 펄프 트레이',
  },
  {
    id: 'item-024',
    code: 'SUP-DIVIDER',
    name: '칸막이 세트',
    category: 'supplies',
    price: 450,
    stock: 650,
    unit: '세트',
    barcode: '8809123456305',
    description: '박스 내 구획용 골판지 칸막이',
  },
];

// 과거 주문 목록 - 농산물 생산자/소규모 거래처
export const pastOrders: POSOrder[] = [
  {
    id: 'order-001',
    orderNo: 'POS-20250128-0001',
    items: [
      { item: items[0], quantity: 50, discount: 0 }, // 사과박스 10kg
      { item: items[19], quantity: 5, discount: 0 }, // 박스 테이프
    ],
    subtotal: 157500,
    discount: 0,
    tax: 15750,
    total: 173250,
    payments: [{ method: 'card', amount: 173250, reference: 'AP123456' }],
    paidAmount: 173250,
    change: 0,
    status: 'paid',
    customer: '청송사과영농조합',
    createdAt: '2025-01-28T09:15:00',
    completedAt: '2025-01-28T09:16:30',
  },
  {
    id: 'order-002',
    orderNo: 'POS-20250128-0002',
    items: [
      { item: items[7], quantity: 100, discount: 5 }, // 딸기박스 3kg 5% 할인
    ],
    subtotal: 171000,
    discount: 9000,
    tax: 17100,
    total: 179100,
    payments: [{ method: 'cash', amount: 180000 }],
    paidAmount: 180000,
    change: 900,
    status: 'paid',
    customer: '논산딸기작목반',
    createdAt: '2025-01-28T10:30:00',
    completedAt: '2025-01-28T10:31:15',
  },
  {
    id: 'order-003',
    orderNo: 'POS-20250128-0003',
    items: [
      { item: items[5], quantity: 30, discount: 0 }, // 감귤박스 20kg
      { item: items[6], quantity: 50, discount: 0 }, // 감귤박스 10kg
      { item: items[20], quantity: 10, discount: 0 }, // 완충재
    ],
    subtotal: 233000,
    discount: 0,
    tax: 23300,
    total: 256300,
    payments: [{ method: 'card', amount: 256300, reference: 'AP123457' }],
    paidAmount: 256300,
    change: 0,
    status: 'paid',
    customer: '서귀포감귤농원',
    createdAt: '2025-01-28T11:45:00',
    completedAt: '2025-01-28T11:47:20',
  },
  {
    id: 'order-004',
    orderNo: 'POS-20250128-0004',
    items: [
      { item: items[14], quantity: 20, discount: 0 }, // 선물세트박스 (소)
      { item: items[15], quantity: 15, discount: 0 }, // 선물세트박스 (중)
    ],
    subtotal: 172500,
    discount: 0,
    tax: 17250,
    total: 189750,
    payments: [{ method: 'transfer', amount: 189750, reference: 'TR98765' }],
    paidAmount: 189750,
    change: 0,
    status: 'paid',
    customer: '한빛농산물유통',
    createdAt: '2025-01-28T13:20:00',
    completedAt: '2025-01-28T13:22:00',
  },
  {
    id: 'order-005',
    orderNo: 'POS-20250128-0005',
    items: [
      { item: items[2], quantity: 40, discount: 5 }, // 배박스 15kg 5% 할인
    ],
    subtotal: 133000,
    discount: 7000,
    tax: 13300,
    total: 139300,
    payments: [],
    paidAmount: 0,
    change: 0,
    status: 'cancelled',
    note: '고객 요청으로 취소 (납품 일정 변경)',
    createdAt: '2025-01-28T14:00:00',
  },
  {
    id: 'order-006',
    orderNo: 'POS-20250127-0015',
    items: [
      { item: items[8], quantity: 80, discount: 0 }, // 채소박스 10kg
      { item: items[23], quantity: 80, discount: 0 }, // 칸막이 세트
    ],
    subtotal: 204000,
    discount: 0,
    tax: 20400,
    total: 224400,
    payments: [{ method: 'card', amount: 224400, reference: 'AP123450' }],
    paidAmount: 224400,
    change: 0,
    status: 'paid',
    customer: '가락시장 김상회',
    createdAt: '2025-01-27T16:30:00',
    completedAt: '2025-01-27T16:32:00',
  },
];

// 카테고리별 상품 필터
export function getItemsByCategory(categoryId: string): POSItem[] {
  if (categoryId === 'all') return items;
  return items.filter((item) => item.category === categoryId);
}

// 상품 검색
export function searchItems(query: string): POSItem[] {
  const lowerQuery = query.toLowerCase();
  return items.filter(
    (item) =>
      item.name.toLowerCase().includes(lowerQuery) ||
      item.code.toLowerCase().includes(lowerQuery) ||
      item.barcode?.includes(query)
  );
}

// 상품 ID로 조회
export function getItemById(id: string): POSItem | undefined {
  return items.find((item) => item.id === id);
}
